<template>
  <div class="wrapper">
    <headNav :routeAddress="address">
      <div slot="headNavText">{{$t('message.basc_info')}}</div>
    </headNav>
    <div style="padding-top: 1.6rem"></div>
    <div class="goback" @click="goback"><i class="el-icon-arrow-left"></i></div>
    <div class="model" v-show="model" @click="model = false">
      <div class="model-show">
        <img :src="modelSrc" alt="">
      </div>
    </div>
    <div class="content">

      <div class="show-info">
        <div class="test">
          <vueCropper ref="cropper2" :img="img" :outputSize="example2.size" :outputType="example2.outputType"
                      :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
                      :autoCropWidth="example2.autoCropWidth" :autoCropHeight="example2.autoCropHeight"
                      :fixed="example2.fixed"
                      :fixedNumber="example2.fixedNumber" :enlarge="4" :canMove="true" mode="cover"></vueCropper>
        </div>
        <!--        <button @click="finish2()" class="btn" :disabled="btn_cj" ref="btn_cjs" block>{{$t('message.deal_photo_cj')}}</button>-->
        <!--        <button @click="roteImg()" class="btn" block>{{$t('message.deal_photo_xz')}}</button>-->
        <!--        <button @click="subImg" class="btn sub" block>{{$t('message.deal_photo_tjtp')}}</button>-->


        <van-button type="info" @click="finish2()" block class="btn" :disabled="btn_cj">
          {{$t('message.deal_photo_cj')}}
        </van-button>
        <van-button type="primary" block @click="subImg" class="btn">{{$t('message.deal_photo_tjtp')}}</van-button>

        <div style="padding: 1.5rem 0 0">
          <h3 style="margin-bottom: 0.5rem">{{$t('message.deal_photo_cz')}}</h3>
          <p style="margin-bottom: 1rem">{{$t('message.deal_photo_text')}}</p>
          <div style="text-align: center">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import img1  from '../../../assets/image/bg2.jpg';
  import {hongkPostImg, idcard_verify} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "wrapper",
    data() {
      return {
        model: false,
        modelSrc: '',
        imgType: '',
        crap: false,
        previews: {},
        showLoading: false,
        form: {
          head: ''
        },
        example2: {
          //img的路径自行修改
          // img: img1,
          info: true,
          size:1,
          outputType: 'jpeg',
          canScale: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          // autoCropWidth: 300,
          // autoCropHeight: 250,
          fixed: true,
          // 真实的输出宽高
          infoTrue: true,
          fixedNumber: [3, 2]
        },
        downImg: '#',
        baseUrl: sessionStorage.getItem("sfzzm"),
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        address: '/photos',
        btn_cj: false
      }
    },
    created() {
      this.img = this.baseUrl;
      this.imgType = this.$route.query.img;
    },
    components: {
      headNav
    },
    methods: {
      goback() {
        this.$router.go(-1);
      },
      finish2(e) {
        this.$refs.cropper2.getCropData((data) => {
          this.modelSrc = data;
          this.model = false;
          //裁剪后的图片显示
          this.img = this.modelSrc;
          this.baseUrl.base64 = this.modelSrc;
          this.example2.autoCrop = false;//关闭裁剪框
          this.btn_cj = true;
        });
      },
      roteImg() {
        this.$refs.cropper2.rotateRight(45)
      },

      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
      },
      subImg() {
        this.showLoading = true;
        hongkPostImg({userid: this.tk.userid, img: this.img, imgname: this.imgType})
          .then(res => {
            this.showLoading = false;
            if (this.imgType == 'img1') {
              if (res.data.code == 200) {
                this.$router.push({path: '/photos', query: {sendImgurl: res.data.data, img: this.imgType}});
                if (this.imgType == 'img1') {
                  sessionStorage.setItem("imgUrl1", res.data.data);
                  sessionStorage.setItem("baseimgUrl1",this.img);
                } else {
                  sessionStorage.setItem("imgUrl2", res.data.data);
                  sessionStorage.setItem("baseimgUrl2",this.img);
                }
              } else {
                this.$notify({type: 'danger', message: res.data.msg});//图片上传不成功，请重新上传
                this.$router.push('/photos')
              }
            } else {
              if (res.data.code == 200) {

                // this.IDcardZMUrl=res.data.data;
                this.$router.push({path: '/photos', query: {sendImgurl: res.data.data, img: this.imgType}})
                if (this.imgType == 'img1') {
                  sessionStorage.setItem("imgUrl1", res.data.data);
                  sessionStorage.setItem("baseimgUrl1",this.img);
                } else {
                  sessionStorage.setItem("imgUrl2", res.data.data);
                  sessionStorage.setItem("baseimgUrl2",this.img);
                }
              } else {
                this.$notify({type: 'danger', message: this.$t('message.img_upload_agagin')});//图片上传不成功，请重新上传
              }
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
    }
  }
</script>

<style scoped>
  .sub {
    background: #8402c7 !important;
    border-color: #8402c7 !important;
  }

  * {
    margin: 0;
    padding: 0;
  }

  .content {
    margin: auto;
    max-width: 585px;
    margin-bottom: 100px;
  }

  .test-button {
    display: flex;
    flex-wrap: wrap;
  }

  .des {
    line-height: 30px;
  }

  code.language-html {
    padding: 10px 20px;
    margin: 10px 0px;
    display: block;
    background-color: #333;
    color: #fff;
    overflow-x: auto;
    font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo, Lucida, Sans, Type, Writer, Ubuntu, Mono;
    border-radius: 5px;
    white-space: pre;
  }

  .show-info {
    margin-bottom: 50px;
  }

  .show-info h2 {
    line-height: 50px;
  }

  .title {
    display: block;
    text-decoration: none;
    text-align: center;
    line-height: 1.5;
    margin: 20px 0px;
    background-image: -webkit-linear-gradient(left, #3498db, #f47920 10%, #d71345 20%, #f7acbc 30%, #ffd400 40%, #3498db 50%, #f47920 60%, #d71345 70%, #f7acbc 80%, #ffd400 90%, #3498db);
    color: transparent;
    -webkit-background-clip: text;
    background-size: 200% 100%;
    animation: slide 5s infinite linear;
    font-size: 40px;
  }

  .test {
    height: 285px;
  }

  .model {
    position: fixed;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .model-show {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }

  .model img {
    display: block;
    margin: auto;
    max-width: 80%;
    user-select: none;
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
  }

  .c-item {
    display: block;
    padding: 10px 0;
    user-select: none;
  }

  @keyframes slide {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: -100% 0;
    }
  }

  @media screen and (max-width: 1000px) {
    .content {
      max-width: 90%;
      margin: auto;
    }

    .test {
      height: 250px;
    }
  }

  .goback {
    position: absolute;
    top: 5.2rem;
    left: 1rem;
  }

  .goback i {
    font-size: 1.5rem;
  }

  @media (min-width: 768px) {
    .goback {
      position: absolute;
      top: 120px;
      left: 1rem;
    }

    .goback i {
      font-size: 1.5rem;
    }
  }

  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(200, 201, 204, 0.6);;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn {
    border-radius: 25px !important;
    color: #fff;
    margin-top: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/deal_photo.vue